// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 1,
        borderWidthFocus: 2,
        borderWidthError: 2,
    },
    productListControllerContainerId: "productListControllerContainer",
    defaultHeaderHeight: {
        mainHeight: 90,
        secondaryHeight: 32,
    },
    roundingRulesTypes: {
        multipleOnly: "Multiple Only",
    },
    cookieNames: {
        viewedCookiePolicy: "viewed_cookie_policy",
    },
    userCannotSeePricesMessage: translate("Price unavailable, contact your supervisor for pricing"),
    pageType: {
        blogPost: "BlogPage",
        blogHome: "BlogHomePage",
        blogList: "BlogListPage",
        issueTracker: "IssueTrackerPage",
    },
    widgetGroup: {
        blogList: "Blog List",
        blogPage: "Blog Page",
    },
    documentTypes: {
        videos: "videoLink",
    },
    attributeTypes: {
        BCHVendorSku: "ItemBCHVendorSku",
    },
    imageTypes: {
        sizeChart: "SizeChart",
        seriesBadges: "Logo",
    },
    productWarnings: {
        prop65: {
            warning: "ProductProp65Warning",
            none: "ProductProp65Warning_None",
        },
    },
    themesNames: {
        common: "common",
        sas: "sas",
    },
});
